import { SettingsTypes } from './types';
import { modes, gsap } from '@powerplay/common';
export class Settings {
    sendSaveSettingsRequestCallback;
    debounceInterval;
    lastSavedSettings = {
        [SettingsTypes.quality]: {
            value: 0,
            name: SettingsTypes.quality
        },
        [SettingsTypes.sounds]: {
            value: 0,
            name: SettingsTypes.sounds
        },
        [SettingsTypes.qualityAuto]: {
            value: 0,
            name: SettingsTypes.qualityAuto
        },
        [SettingsTypes.isLeft]: {
            value: 0,
            name: SettingsTypes.isLeft
        },
        [SettingsTypes.controlsType]: {
            value: 0,
            name: SettingsTypes.controlsType
        },
        [SettingsTypes.aimSensitivity]: {
            value: 0,
            name: SettingsTypes.aimSensitivity
        },
        [SettingsTypes.vibrations]: {
            value: 0,
            name: SettingsTypes.vibrations
        },
        [SettingsTypes.oneFinger]: {
            value: 0,
            name: SettingsTypes.oneFinger
        }
    };
    settings = {
        [SettingsTypes.quality]: {
            value: 0,
            name: SettingsTypes.quality
        },
        [SettingsTypes.sounds]: {
            value: 0,
            name: SettingsTypes.sounds
        },
        [SettingsTypes.qualityAuto]: {
            value: 0,
            name: SettingsTypes.qualityAuto
        },
        [SettingsTypes.isLeft]: {
            value: 0,
            name: SettingsTypes.isLeft
        },
        [SettingsTypes.controlsType]: {
            value: 0,
            name: SettingsTypes.controlsType
        },
        [SettingsTypes.aimSensitivity]: {
            value: 3,
            name: SettingsTypes.aimSensitivity
        },
        [SettingsTypes.vibrations]: {
            value: 1,
            name: SettingsTypes.vibrations
        },
        [SettingsTypes.oneFinger]: {
            value: 0,
            name: SettingsTypes.oneFinger
        }
    };
    startQualityValue = 0;
    constructor(sendSaveSettingsRequestCallback) {
        this.sendSaveSettingsRequestCallback = sendSaveSettingsRequestCallback;
    }
    getSetting(type) {
        return this.settings[type].value ?? 0;
    }
    getSettings() {
        return this.settings;
    }
    init(updateAudioCallback, updateQualityCallback, updateIsLeftCallback, updateAimSensitivityCallback, updateVibrationsCallback, updateOneFingerCallback) {
        this.settings.quality.method = updateQualityCallback;
        this.settings.sounds.method = updateAudioCallback;
        this.settings.isLeft.method = updateIsLeftCallback;
        this.settings.aimSensitivity.method = updateAimSensitivityCallback;
        this.settings.vibrations.method = updateVibrationsCallback;
        this.settings.oneFinger.method = updateOneFingerCallback;
    }
    setValues(settedValues) {
        const keys = Object.keys(this.settings);
        keys.forEach((key) => {
            const settedValue = settedValues[key];
            if (!settedValue)
                return;
            if (settedValues)
                settedValue.value = parseInt(settedValue.value.toString());
            this.settings[key] = {
                ...this.settings[key],
                ...settedValue
            };
            this.lastSavedSettings[key] = {
                ...this.lastSavedSettings[key],
                ...settedValue
            };
        });
        console.log('Settings init ...', JSON.parse(JSON.stringify(this.settings)));
    }
    update(key, settedValue) {
        console.log('SETTING UPDATE');
        console.log(`setting update ${key} = ${settedValue}?`);
        if (this.settings[key]) {
            if (this.settings[key].value === settedValue)
                return;
            console.log(`setting update ${key} = ${settedValue}`);
            this.settings[key].value = settedValue;
            this.settings[key].method?.(settedValue);
        }
        else {
            throw Error(`Setting ${key} or his method is not specified!`);
        }
    }
    updateAllOnStart() {
        Object.values(this.settings).forEach((setting) => {
            if (setting.method)
                setting.method(setting.value);
        });
        this.startQualityValue = this.settings.quality.value;
    }
    saveValues(withoutInterval = false) {
        if (modes.isExternalApp) {
            window.localStorage.setItem('settingsMinigameExternalApp', JSON.stringify(this.settings));
            return;
        }
        if (this.compareLastSavedToNew()) {
            if (withoutInterval) {
                this.sendValuesToServer();
            }
            else if (!this.debounceInterval) {
                this.debounceInterval = gsap.to(this, {
                    duration: 2,
                    onComplete: this.sendValuesToServer
                });
            }
            else {
                this.debounceInterval.restart();
            }
        }
        else {
            this.debounceInterval?.kill();
            this.debounceInterval = undefined;
        }
    }
    sendValuesToServer = () => {
        console.log('sending data to server');
        const data = {
            system_config: [
                this.settings.quality,
                this.settings.sounds,
                this.settings.qualityAuto,
                this.settings.isLeft,
                this.settings.controlsType
            ]
        };
        if (this.settings.aimSensitivity.method) {
            data.system_config.push(this.settings.aimSensitivity);
        }
        if (this.settings.vibrations.method) {
            data.system_config.push(this.settings.vibrations);
        }
        if (this.settings.oneFinger.method) {
            data.system_config.push(this.settings.oneFinger);
        }
        this.sendSaveSettingsRequestCallback(JSON.stringify(data));
        this.debounceInterval = undefined;
        this.lastSavedSettings = JSON.parse(JSON.stringify(this.settings));
    };
    compareLastSavedToNew = () => {
        const keys = Object.keys(this.settings);
        let result = false;
        keys.forEach((key) => {
            if (this.settings[key].value !== this.lastSavedSettings[key].value) {
                result = true;
            }
        });
        return result;
    };
    isControlsTypeByParam(type) {
        return type === this.settings.controlsType.value;
    }
}
//# sourceMappingURL=Settings.js.map